import { atom } from 'jotai';

import { relationsByParentMapAtom } from '@store';

import { LayoutArea, LayoutModule, Size } from './types';

export const indicatorIndexAtom = atom<number | null>(null);
export const indicatorRowSpanAtom = atom<number>(1);
export const indicatorColSpanAtom = atom<number>(1);
export const gridModulesAtom = atom<LayoutModule[]>([]);
export const selectedAreaAtom = atom<LayoutArea | null>(null);
export const slotSizeAtom = atom<Size | null>(null);
export const graphLinesMapAtom = atom<Record<string, string[] | undefined>>({});

type ToggleGraphLineArgs = {
    moduleId: string;
    graphLineId: string;
};
export const toggleGraphLineAtom = atom<null, [args: ToggleGraphLineArgs], unknown>(
    null,
    (get, set, { moduleId, graphLineId }) => {
        const graphLinesMap = get(graphLinesMapAtom);

        /**
         * When we click on an empty map, we assume that all graph lines are enabled.
         * Which means a default map, must include all graph lines.
         *
         * If no map is provided, we also assume that all graph lines are enabled.
         */
        const relationsByParentMap = get(relationsByParentMapAtom);
        const defaultGraphLines = relationsByParentMap[moduleId]?.map(({ childUiNodeId }) => childUiNodeId);
        const moduleGraphLines = graphLinesMap[moduleId] || [...defaultGraphLines];

        const updatedModuleGraphLines = moduleGraphLines.includes(graphLineId)
            ? moduleGraphLines.filter((id) => id !== graphLineId)
            : [...moduleGraphLines, graphLineId];
        set(graphLinesMapAtom, { ...graphLinesMap, [moduleId]: updatedModuleGraphLines });
    },
);
